import { ApiUrl } from "../../../Constants/Api";
import {
  REQUEST_METHOD,
  WebService,
} from "../../WebServiceManager/RequestService";
import ProfileRequestBody from "./ProfileRequestBody";

export default class ProfileService {
  request = new ProfileRequestBody();
  static shared = new ProfileService();

  updateprofileUserRequest = (payload) => {

  return new Promise((resolve, reject) => {
    WebService.clientShared
      .callServiceApi(
        ApiUrl.updateProfileUser(),  // Ensure payload is NOT passed inside URL
        this.request.updateProfileUserRequest(REQUEST_METHOD.PUT, payload.user)
      )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

uploadProfilePictureRequest= (payload) => {
  return new Promise((resolve, reject) => {
    WebService.clientShared
      .callServiceApi(
        ApiUrl.uploadProfilePicture(),  
        this.request.uploadProfilePictureRequest(REQUEST_METHOD.POST,payload)
      )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

getProfilePictureRequest = (payload) => {
  return new Promise((resolve, reject) => {
    WebService.clientShared
      .callServiceApi(
        ApiUrl.getProfilePicture(),
        this.request.getProfilePictureRequest(REQUEST_METHOD.GET)
      )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

uploadCoverImageRequest = (payload) => {
  return new Promise((resolve, reject) => {
    WebService.clientShared
      .callServiceApi(
        ApiUrl.uploadCoverImage(),
        this.request.uploadCoverImageRequest(REQUEST_METHOD.POST,payload)
      )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

getCoverImageRequest = (payload) => {
  return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.getCoverImage(),
          this.request.getCoverImageRequest(REQUEST_METHOD.GET)
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
          });
          });
          };

}
